$(document).ready(function(){

  if($('body').hasClass('TEMP-stealth')){
      setTimeout(function(){
        var SelectVal = $('input.input-radio-wp:checked').val();
        console.log("Select Value : " + SelectVal)
        if(SelectVal == "Standard"){
          $('#impressionDiv').addClass('hide_this');
          $('.product__info-wrapper').addClass('color-filter-hide');
        }
        else{
          $('#impressionDiv').removeClass('hide_this');
          $('.product__info-wrapper').removeClass('color-filter-hide');
        }
      },500);
  }

  $(document).on('click','.product-swatch-main-wp',function(){

    var CurrentValue = $('.selected--item-text .selected_label').text().trim();
    setTimeout(function(){
          if(CurrentValue == "Send your print digitally" || CurrentValue == "Send dit aftryk digitalt"){
      $('.form-control-image').attr('required',true);
    }
    else{
      $('.form-control-image').attr('required',false);
    }
    },500);
    
    if($('body').hasClass('TEMP-stealth')){
      setTimeout(function(){
        var SelectVal = $('input.input-radio-wp:checked').val();
        if(SelectVal == "Standard"){
          $('#impressionDiv').addClass('hide_this');
          $('.product__info-wrapper').addClass('color-filter-hide');
        }
        else{
          $('#impressionDiv').removeClass('hide_this');
          $('.product__info-wrapper').removeClass('color-filter-hide');
        }
      },500);
    }
  })


  
 $('.hero_banner_flex').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  adaptiveHeight: true
});



// $(".play_button.play").click(function () {
//   $(this).hide(),
//   $(this).parents(".video_right_box").find("video").get(0).play();
//   $(this).parents(".video_right_box").find("video").removeAttr("playsinline");
//   $(this).parents(".video_right_box").find("video").removeAttr("muted");
// }),
// $(".video_right_box video").click(function () {
//   $(".play_button").show(),
//   $(this).parents(".video_right_box").find("video").get(0).pause();
//   $(this).parents(".video_right_box").find("video").attr("playsinline");
//   $(this).parents(".video_right_box").find("video").attr("muted");
// });

  
  // $(".play_button.play").click(function () {
  //   $(this).hide(); // Hides the play button
  //   const videoElement = $(this).parents(".video_right_box").find("video").get(0);
  //   videoElement.play(); // Plays the video
  //   $(videoElement).attr("playsinline", "true"); // Removes the playsinline attribute
  //   $(videoElement).removeAttr("muted"); // Removes the muted attribute
  //   $(videoElement).attr("controls", "true"); // Ensures the controls remain visible
  //   console.log("Video Play");
  // });
  
  // $(".video_right_box video").click(function () {
  //   $(".play_button").show(); // Shows the play button
  //   const videoElement = $(this).get(0);
  //   videoElement.pause(); // Pauses the video
  //   $(videoElement).removeAttr("playsinline"); // Adds the playsinline attribute back
  //   $(videoElement).attr("muted", "true"); // Adds the muted attribute back
  //   $(videoElement).removeAttr("controls"); // Ensures the controls remain visible
  //   console.log("Video Pause");
  // });

  $(".play_button.play").click(function () {
      $(this).hide(); // Hide the play button
      const videoElement = $(this).parents(".video_right_box").find("video").get(0);
      $(videoElement).attr("controls", "true"); // Add controls attribute
      videoElement.play(); // Play the video
      $(videoElement).attr("playsinline", "true"); // Remove playsinline attribute
      $(videoElement).prop("muted", false); // Unmute the video
      console.log("Video Play");
  });
  
  $(".video_right_box video").click(function () {
      const videoElement = $(this).get(0);
      videoElement.pause(); // Pause the video
      $(".play_button").show(); // Show the play button
      $(videoElement).removeAttr("playsinline"); // Add playsinline attribute
      $(videoElement).prop("muted", true); // Mute the video
      $(videoElement).removeAttr("controls"); // Remove controls attribute
      console.log("Video Pause");
  });





    $('.faq_heading_col:not(".js_disable")').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.faq_desc').slideUp();
        $(this).removeClass('active');
      }
      else {
      $('.faq_desc').slideUp();
        $('.faq_heading_col').removeClass('active');
        $(this).siblings('.faq_desc').slideToggle();
        $(this).toggleClass('active');
      }
    });


      
      $('.product-popup-modal__opener').hide();
      $('.product-popup-modal_button').hide();
      $('fieldset.product-form__input label').hide();
  
      $(document).on('click', '.form__label', function(event) {
          var $currentLabel = $(this);
          $currentLabel.toggleClass('active');
          $currentLabel.siblings('.product .product-form__input label').slideToggle();
        $('.impression-error-wp').text(" ");
      });
      // Choose button click jquery
      $(document).on('click', '.choose_label .form__label', function() {
        if($(this).hasClass('active')) {
          $('.product-popup-modal__opener').slideToggle();
        } else {
          $('.product-popup-modal__opener').slideUp();
        }
      });
      // SELECT FILTER click jquery
      $(document).on('click', '.select-filter-variant .form__label', function() {
        if($(this).hasClass('active')) {
          $('.product-popup-modal_button').slideToggle();
        } else {
          $('.product-popup-modal_button').slideUp();
        }
      });

  $(document).on('click','.product-form__input--pill label',function(){
    var selectData = $(this).attr('attr_label');
    if(selectData == "Send your print digitally" || selectData == "Send dit aftryk digitalt"){
      $('.form-control-image').attr('required',true);
    }
    else{
      $('.form-control-image').attr('required',false);
    }
  });


//   $(document).on('click','.product_locality_box.btn-disable a',function(e){
//     e.preventDefault();
//     console.log("alter");
//     var selectImage = $('.form-control-image').val();
//     if(selectImage == "" || selectImage == " "){
//       alert("please select image !!")
//     }
//   })
// $('.product_locality_box').removeClass('btn-disable');

// $('input.form-control-image[type="file"]').on('change', function() {
//   const file = this.files[0];
//   if (file && file.type.startsWith('image/')) {
//     console.log("test");
//     $('.product_locality_box').removeClass('btn-disable');
//   }
// });

  
  
      // $(document).on('click', 'fieldset.product-form__input label', function(event) {
      //     // console.log(event);
      //     // var main_variant_selects = $(event.target).parents('variant-selects').html();  // Fixed
      //     // var variant_selects = $('variant-selects').html();  // Fixed
      //     // setTimeout(function() {
      //     //     console.log("variant-selects", main_variant_selects);
      //     //     $('variant-selects').html(main_variant_selects);  // Fixed
      //     // }, 1000);

      //   // $('.product-popup-modal__opener').hide();
      //   // $('.product-popup-modal_button').hide();
      //   // $('fieldset.product-form__input label').hide();
      //    // $('.form__label').trigger("click");

      //   // Call the globally accessible function
      //   const selectedValues = window.selectedOptionValues();
      //   console.log(selectedValues);

      // });

       



  
      // $('.product-popup-modal__opener').hide();
      // $(document).on('click', '.form__label', function() {
      //   if($(this).hasClass('active')) {
      //     $(this).siblings('.product .product-form__input label').slideUp();
      //     // $('.product-popup-modal__opener').slideUp();
      //     $(this).removeClass('active');
      //   } else {
      //     $('.product .product-form__input label').slideUp();
      //     $('.product-popup-modal__opener').slideUp();
      //     $('.form__label').removeClass('active');
      //     $(this).siblings('.product .product-form__input label').slideToggle();
      //     // $('.product-popup-modal__opener').slideToggle();
      //     $(this).toggleClass('active');
      //     $('.product-popup-modal_button').slideUp();
      //   }
      // });

      // Choose button click jquery
      // $('.product-popup-modal__opener').hide();
      // $(document).on('click', '.choose_label .form__label', function() {
      //   if($(this).hasClass('active')) {
      //     // $('.product-popup-modal__opener').slideToggle();
      //     $('.product-popup-modal__opener').slideToggle();
      //   } else {
      //     // $('.product-popup-modal__opener').slideUp();
      //     $('.product-popup-modal__opener').slideUp();
      //   }
      // });

      // SELECT FILTER click jquery
      // $('.product-popup-modal_button').hide();
      // $(document).on('click', '.select-filter-variant .form__label', function() {
      //   if($(this).hasClass('active')) {
      //     // $('.product-popup-modal__opener').slideToggle();
      //     $('.product-popup-modal_button').slideToggle();
      //   } else {
      //     // $('.product-popup-modal__opener').slideUp();
      //     $('.product-popup-modal_button').slideUp();
      //   }
      // });

      // Choose button Hide / Show on label click jquery
      // $('.custom-file-selecter input[type="file"]').hide();
      // $(document).on('click', '.custom-file-selecter .pd-form__label', function() {
      //   if($(this).hasClass('active')) {
      //     $('.custom-file-selecter input[type="file"]').slideToggle();
      //     $(this).toggleClass('active');
      //   } else {
      //     $(this).toggleClass('active');
      //     $('.custom-file-selecter input[type="file"]').slideToggle();
      //   }
      // });


$('.product_faq_heading').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.product_faq_desc').slideUp();
    $(this).removeClass('active');
  }
  else {
    $('.product_faq_desc').slideUp();
    $('.product_faq_heading').removeClass('active');
    $(this).siblings('.product_faq_desc').slideToggle();
    $(this).toggleClass('active');
  }
});


  // cart page js
  $(".cart__main_header-wrapper , .cart__footer-wrapper").wrapAll( "<div class='cart__page_flex-wrapper' />");
  $(".cart__page_flex-wrapper").wrapAll( "<div class='container' />");
  $(".cart_bottom_btn").appendTo(".cart__page_flex-wrapper");

  
});


// document.addEventListener('DOMContentLoaded', function() {
//         // Select the variant selects element
//         const variantSelects = document.getElementById('variant-selects-template--17025394639004__main');
        
//         // Add event listeners to all radio buttons inside the variant selects
//         const radioButtons = variantSelects.querySelectorAll('input[type="radio"]');
//         radioButtons.forEach(button => {
//           button.addEventListener('change', handleVariantChange);
//         });
      
//         function handleVariantChange() {
//           // Get the selected options
//           const formData = new FormData();
//           radioButtons.forEach(button => {
//             if (button.checked) {
//               formData.append(button.name, button.value);
//             }
//           });
      
//           // Fetch the updated HTML content
//           // fetch(`/products/${productHandle}.js?section_id=variant-selects-template--17025394639004__main`)
//           const productUrl = this.dataset.url.split('?')[0];
//           fetch('${productUrl}', {
//             method: 'POST',
//             body: formData
//           })
//           .then(response => response.text())
//           .then(html => {
//             // Replace the content inside the variant selects element
//             setTimeout(() => {
//               variantSelects.innerHTML = html;
      
//               // Reattach event listeners to the new radio buttons
//               const newRadioButtons = variantSelects.querySelectorAll('input[type="radio"]');
//               newRadioButtons.forEach(button => {
//                 button.addEventListener('change', handleVariantChange);
//               });
//             }, 1000); // Replace after 1 second delay
//           })
//           .catch(error => console.error('Error fetching updated variant selects:', error));
//         }
//       });

// document.addEventListener('DOMContentLoaded', function () {
//     const variantSelectsContainer = document.getElementById('variant-selects-template--17025394639004__main');

//     variantSelectsContainer.addEventListener('change', function (e) {
//         // Find the selected radio button within the fieldset that was clicked
//         const selectedRadio = e.target;

//         // Extract the product URL from the selected radio button's data attribute
//         const productUrl = selectedRadio.getAttribute('data-product-url');

//         if (productUrl) {
//             // Delay the fetch request by 1 second (1000 ms)
//             setTimeout(() => {
//                 fetch(productUrl)
//                     .then(response => response.text())
//                     .then(html => {
//                         // Replace the content of the variant selects container with the new HTML
//                         variantSelectsContainer.innerHTML = html;
//                     })
//                     .catch(error => {
//                         console.error('Error fetching variant data:', error);
//                     });
//             }, 1000); // Set timeout delay (1000 ms = 1 second)
//         }
//     });
// });

// $(document).ready(function(){
//     $(".main_choose_detection_label").click(function(){
//         $(this).next().slideToggle();
//         $(this).toggleClass('active_icon');
//     });
// });